var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#icon-shareicon-77e07';
                    var viewUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#view-icon-shareicon-77e07';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: 'undefined',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };